import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { TextInput } from "@/components";
import { ContainedButton } from "@/common";
import { tokens } from "@/tokens";

export const StyledTextInput = styled(TextInput)({
  borderColor: "#C0C4C4",
  backgroundColor: tokens.bg.surface,
  borderRadius: tokens.radius.sm,
  flexGrow: 1,
  minWidth: "200px",
  maxWidth: "300px",
});
export const StyledContainedButton = styled(ContainedButton)({
  borderRadius: tokens.radius.md,
  boxShadow: "none",
  flexShrink: 0,
  width: "auto",
  padding: "6px 14px",
  height: 34,
  fontSize: tokens.fontSize.sm2,
});

export const HeaderRightNode = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: "100%",
  width: "auto",
  "@media (min-width: 996px) and (max-width: 1104px)": {
    width: "60%",
  },
  "@media (max-width: 528px)": {
    flexWrap: "wrap",
    justifyContent: "center",
  },
});
